<py-responsive-table
  key="ref"
  [entries]="articleResultRefs || []"
  [rowTemplate]="row"
  [listItemTemplate]="listItem"
  [omitTbody]="true"
  [breakpoint]="850"
  *ngIf="{ enableSecondaryArticleRowVariant: enableSecondaryArticleRowVariant$ | async } as data"
>
  <thead *ngIf="(showHeader && !data.enableSecondaryArticleRowVariant) || showDiscontinuedArticleHeader">
    <!-- Table heading is not displayed when using secondary article row variant -->
    <tr *ngIf="showHeader && !data.enableSecondaryArticleRowVariant">
      <th>
        <span class="cx-visually-hidden">{{ 'catalog.articleImage_heading' | cxTranslate }}</span>
      </th>
      <th>{{ 'catalog.article_heading' | cxTranslate }}</th>
      <th>{{ 'catalog.quantityAndUnit_heading' | cxTranslate }}</th>
      <th class="text-right">{{ 'catalog.price_heading' | cxTranslate }}</th>
      <th>
        <span class="cx-visually-hidden">{{ 'catalog.buy_heading' | cxTranslate }}</span>
      </th>
    </tr>

    <tr *ngIf="showDiscontinuedArticleHeader">
      <th class="px-0 pt-4 pb-2" colspan="5" style="font-size: 16px">
        <ng-container *ngTemplateOutlet="headerTitle"></ng-container>
      </th>
    </tr>
  </thead>

  <ng-container slot="list-header">
    <div *ngIf="showDiscontinuedArticleHeader" class="border-bottom px-0 py-2">
      <ng-container *ngTemplateOutlet="headerTitle"></ng-container>
    </div>
  </ng-container>
</py-responsive-table>

<ng-template #row let-entry>
  <tbody
    #catalogArticleListComponent
    py-catalog-article-row
    [itemListType]="itemListType"
    [expandedByDefault]="expandedByDefault"
    [attr.data-articleref]="entry?.ref"
    [articleResultRef]="entry"
    [substituteBadgeType]="getSubstituteBadgeType(entry)"
    [queryParams]="queryParams"
    [partialRenderingEnabled]="partialRenderingEnabled"
    [additionalArticleActions]="additionalArticleActions"
    [hideAddToShoppingListButton]="hideAddToShoppingListButton"
    [showConsignmentStockLevel]="showConsignmentStockLevel"
    [cartType]="cartType"
    [useArticleCartTypeInsteadOfGivenToAddToCart]="useArticleCartTypeInsteadOfGivenToAddToCart"
    [enableSecondaryArticleRowVariant]="enableSecondaryArticleRowVariant$ | async"
    [showAttributesInSeparateColumn]="showAttributesInSeparateColumn"
    [freeTextSearch]="freeTextSearch"
    class="w-100"
  ></tbody>
  <tbody py-catalog-similar-articles-row [articleResultRef]="entry" [articleRowComponent]="catalogArticleListComponent"></tbody>
</ng-template>

<ng-template #listItem let-entry>
  <li
    #catalogArticleListComponent
    py-catalog-article-item
    [itemListType]="itemListType"
    [expandedByDefault]="expandedByDefault"
    [attr.data-articleref]="entry?.ref"
    [articleResultRef]="entry"
    [substituteBadgeType]="getSubstituteBadgeType(entry)"
    [queryParams]="queryParams"
    [partialRenderingEnabled]="partialRenderingEnabled"
    [additionalArticleActions]="additionalArticleActions"
    [hideAddToShoppingListButton]="hideAddToShoppingListButton"
    [showConsignmentStockLevel]="showConsignmentStockLevel"
    [cartType]="cartType"
    [useArticleCartTypeInsteadOfGivenToAddToCart]="useArticleCartTypeInsteadOfGivenToAddToCart"
    [enableSecondaryArticleRowVariant]="enableSecondaryArticleRowVariant$ | async"
    [freeTextSearch]="freeTextSearch"
  ></li>
</ng-template>

<ng-template #headerTitle>
  {{ 'catalog.replacementAlternatives_title' | cxTranslate }}
</ng-template>
